import type en from "../en/languages";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  title: "Langues",
  description: "Vendez dans plusieurs langues. La langue de votre tableau de bord se règle séparément dans la barre du haut ; ici, ce sont les langues dans lesquelles vos clients peuvent lire votre boutique.",
  storefrontLanguages: "Langues de la boutique",
  storefrontLanguagesHint: "La langue par défaut est celle dans laquelle votre contenu est rédigé. Les langues supplémentaires restent masquées aux clients jusqu’à leur publication.",
  addLanguage: "Ajouter une langue",
  default: "Par défaut",
  publishedBadge: "Publiée",
  hiddenBadge: "Masquée aux clients",
  preview: "Aperçu ↗",
  manageTranslations: "Traductions",
  noneYet: "Aucune langue supplémentaire. Ajoutez-en une pour commencer à traduire votre boutique.",
  enabled: "Langue ajoutée. Elle reste masquée jusqu’à sa publication.",
  removed: "Langue supprimée.",
  publish: "Publier",
  unpublish: "Dépublier",
  publishTitle: "Publier {language} ?",
  publishBody: "Les clients pourront passer à cette langue. Toutes ses traductions en brouillon seront mises en ligne ; le texte non traduit s’affiche dans votre langue par défaut.",
  unpublishTitle: "Masquer {language} ?",
  unpublishBody: "Les clients ne verront plus cette langue. Les traductions sont conservées.",
  removeTitle: "Supprimer {language} ?",
  removeBody: "La langue et toutes ses traductions seront supprimées.",
  publishedMsg: "Langue publiée.",
  unpublishedMsg: "Langue masquée aux clients.",
  translationsFor: "Traductions en {language}",
  completeness: "{percent} % du texte de votre boutique est traduit.",
  completenessLabel: "Progression de la traduction",
  hiddenNote: "Cette langue est masquée aux clients. Vérifiez-la avec l’aperçu, puis publiez-la quand vous êtes prêt.",
  colContent: "Contenu",
  colStatus: "Statut",
  colProgress: "Champs",
  status_missing: "Non traduit",
  status_partial: "Partiellement traduit",
  status_complete: "Traduit",
  status_outdated: "À mettre à jour",
  unpublishedChanges: "Modifications non publiées",
  machineTranslated: "Traduction IA",
  edit: "Modifier",
  type_store: "Boutique",
  type_page: "Page",
  type_menu: "Menu",
  type_collection: "Collection",
  type_product: "Produit",
  aiTranslateMissing: "Traduire le manquant avec l’IA",
  aiTranslateThis: "Traduire avec l’IA",
  aiWorking: "Traduction…",
  aiUnavailable: "La traduction IA n’est pas configurée sur ce serveur.",
  aiDone: "{count} éléments traduits en brouillon. Relisez-les avant de publier.",
  aiDone_one: "1 élément traduit en brouillon. Relisez-le avant de publier.",
  editorHint: "Traduire du {from} vers le {to}. Les prix, références, images et liens proviennent toujours de l’original.",
  outdatedNote: "Le texte d’origine a changé depuis cette traduction. Vérifiez les champs ci-dessous.",
  field_title: "Titre",
  field_description: "Description",
  field_seoTitle: "Titre SEO",
  field_seoDescription: "Description SEO",
  field_menuLabel: "Libellé du menu",
  field_section: "Section",
  saveDraft: "Enregistrer le brouillon",
  savedDraft: "Traduction enregistrée en brouillon.",
  publishThis: "Publier cette traduction",
  aiRemaining: "Il reste {count} éléments à traduire — cliquez à nouveau pour continuer.",
  translationPublished: "Traduction publiée.",
};

export default fr;
